import { Button, CityState, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierSelection extends Layout {
    buttonAddSpotQuote: Button;
    buttonChangeMarkups: Button;
    buttonFindCarrierRates: Button;
    buttonP44Settings: Button;
    buttonSmc3Settings: Button;
    citystateConsignee: CityState;
    citystateShipper: CityState;
    horizontalspacer1: HorizontalSpacer;
    labelPickup: Label;
    panelBlueContainer: Panel;
    panelControls: Panel;
    panelErrors: Panel;
    panelOrderStopFields: Panel;
    panelOverview: Panel;
    panelP44: Panel;
    panelSmc3: Panel;
    panelTabRates: Panel;
    panelTableBfg: Panel;
    sourceBrltlBillingFreightGroup: DataSource;
    switchExpandAll: Switch;
    tabErrors: Tab;
    tabModeAndTerms: Tab;
    tabRates: Tab;
    tabSpotQuote: Tab;
    tableBFGs: Table;
    tableErrors: Table;
    tabsetCarrierSelection: Tabset;
    tabsetRatingControls: Tabset;
    tabsetSpotQuote: Tabset;
    textboxAccessorialAmount: Textbox;
    textboxBaseAmount: Textbox;
    textboxCarrier: Textbox;
    textboxFreightClass: Textbox;
    textboxFuelAmount: Textbox;
    textboxP44DirectionOverride: Textbox;
    textboxPaymentTerms: Textbox;
    textboxRatingMode: Textbox;
    textboxReference: Textbox;
    textboxScheduledArrival: Textbox;
    textboxSmc3PayerOverride: Textbox;
    textboxSmc3PaymentTerms: Textbox;
    textboxSmc3RatingMode: Textbox;
    textboxSource: Textbox;
    textboxTotalWeight: Textbox;
    textboxTransitDays: Textbox;
}
